import { Subject } from 'rxjs';
import { BlocksTranslationsType } from '../../model/blocks-types';
import { GameServices } from '../../services/game-services';
import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';

export class LevelViewModel {
  public get levelLabelText() {
    return this.gameServices.gameTranslationService.getTranslation(BlocksTranslationsType.Level);
  }
  public get blocksLogicActionBus$() {
    return this.gameServices.gameRunnerService.blocksLogicActionBus$;
  }
  public get layoutConfig() {
    return this.gameServices.gameMetricsService.gameLayoutConfig;
  }
  public get onGameSetupCompleteTrigger() {
    return this.gameServices.gameRunnerService.onGameSetupCompleteTrigger;
  }
  public get onResetGameScene$() {
    return this.onResetGameScene;
  }

  private readonly onResetGameScene = new Subject<void>();

  constructor(private gameServices: GameServices) {}

  public calculateScaleFactor(gameSizeMetrics: GameSizeMetrics): {
    scaledOffsetX: number;
    scaleFactor: number;
  } {
    return this.gameServices.gameMetricsService.calculateBoardScaling(gameSizeMetrics);
  }

  public resetGameScene() {
    this.onResetGameScene.next();
  }
}
